import { render } from "./QuienesSomos.vue?vue&type=template&id=41cd1358&scoped=true"
import script from "./QuienesSomos.vue?vue&type=script&lang=js"
export * from "./QuienesSomos.vue?vue&type=script&lang=js"

import "./QuienesSomos.vue?vue&type=style&index=0&id=41cd1358&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cd1358"]])

export default __exports__